var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_vm._v("Copyright © "+_vm._s(_vm.year)+" "+_vm._s(_vm.ownerName))])}
var staticRenderFns = []

export { render, staticRenderFns }